import "core-js/modules/es.number.constructor.js";
import { defineComponent } from "vue";
export default defineComponent({
  name: "pagination",
  props: {
    pageInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    total: {
      type: Number,
      default: 0
    },
    curtPage: {
      type: Number,
      default: 1
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;

    var changeCurrent = function changeCurrent(page) {
      emit("changeCurrent", page);
    };

    return {
      changeCurrent: changeCurrent
    };
  },
  components: {}
});